

import store from '@/store'
export default [
  {
    path: '/checkout',
    component: () => import('@/views/checkout/CheckoutView.vue'),
    meta: { 
      title: 'Checkout', 
      requiresAuth: true,
      requiresAmazon: true
    },
    children: [
      {
        path: 'shipping-addresses',
        component: () => import('@/views/checkout/ShippingAddresses.vue'),
      },
      {
        path: 'assign-shipping-locations',
        component: () => import('@/views/checkout/AssignShippingLocations.vue'),
        beforeEnter: (to, from, next) => {
          const canContinueAddress = store.getters['checkout/canContinueAddress']

          if (!canContinueAddress) {
            return next('/checkout/shipping-addresses')
          }

          next()
        }
      },
      {
        path: 'payment-methods',
        component: () => import('@/views/checkout/PaymentMethods.vue'),
        beforeEnter: (to, from, next) => {
          const canContinueAddress = store.getters['checkout/canContinueAddress']
          const hasAcceptedItems = store.getters['checkout/hasAcceptedItems']
          if (!canContinueAddress ) {
            return next('/checkout/shipping-addresses')
          }

          if (!hasAcceptedItems) {
            return next('/checkout/assign-shipping-locations')
          }

          next()
        }
      },
      {
        path: 'review-and-checkout',
        component: () => import('@/views/checkout/ReviewAndCheckout.vue'),
        beforeEnter: (to, from, next) => {
          const canContinuePayment = store.getters['checkout/canContinuePayment']
          if (!canContinuePayment) {
            return next('/checkout/payment-methods')
          }

          next()
        }
      }
    ]
  }
]
